import { Hero } from "@/components/hero/Hero";
import { Benefits } from "@/components/Benefits";
import { Transformation } from "@/components/Transformation";
import { Testimonials } from "@/components/Testimonials";
import { FAQ } from "@/components/FAQ";
import { Footer } from "@/components/Footer";
import FinalCTA from "@/components/FinalCTA";
import { Warranty } from "@/components/metodolda/Warranty"

const Index = () => {
  return (
    <div className="min-h-screen bg-background text-foreground overflow-hidden">
      <Hero />
      <Testimonials />
      <Transformation />
      <Benefits />
      <FinalCTA />
      <Warranty />
      <FAQ />
      <Footer />
    </div>
  );
};

export default Index;
